import { Badge, BadgeSize, BadgeVariant } from "shared/components";
import type { UndeliverableNumber } from "views/inbox/types";
import {
  CANT_TEXT_BADGE_LABEL,
  cantTextBadgeTooltip
} from "shared/utils/sms-undeliverable";

export const CantTextBadge = ({
  status
}: {
  status?: UndeliverableNumber | null;
}) =>
  status ? (
    // leading-none: the tooltip trigger otherwise inherits the table cell's
    // line height and pushes the row apart.
    <span className="inline-flex shrink-0 leading-none">
      <Badge
        variant={BadgeVariant.ERROR}
        size={BadgeSize.SM}
        className="whitespace-nowrap text-danger-700"
        tooltip={cantTextBadgeTooltip(status)}
        tooltipClassName="max-w-[300px]"
        placement="top"
      >
        {CANT_TEXT_BADGE_LABEL}
      </Badge>
    </span>
  ) : null;
